require('babel-polyfill')



// WEBPACK FOOTER //
// /opt/build/repo/src/polyfills.js